import { VFC, useMemo } from 'react';
import { MAX_CURRENT_VALUES, MaxCurrent, UNIT_TRANSLATED, Unit } from '@enmon/commons';
import { useIntl } from 'react-intl';
import { Select } from '../../Select';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface MaxCurrentSelectProps {
  value?: MaxCurrent;
  onChange?: (value: MaxCurrent) => void;
}

export const MaxCurrentSelect: VFC<MaxCurrentSelectProps> = ({ ...restProps }: MaxCurrentSelectProps) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const maxCurrentOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: MAX_CURRENT_VALUES,
        suggestedValue: meterModelSuggestions?.iMax?.value,
        suggestedSelection: meterModelSuggestions?.iMax?.selection,
      }),
    [intl, meterModelSuggestions],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={maxCurrentOptions}
      placeholder={MaxCurrent['MaxCurrent-63']}
      suffix={UNIT_TRANSLATED[Unit.A]}
      {...restProps}
    />
  );
};
